module.exports = __webpack_public_path__ + "img/icon4.ec1c97a4.png";